module.exports = __webpack_public_path__ + "img/not-found-lesson.ecb1a66f.svg";